module.exports = __webpack_public_path__ + "static/media/HW_updateThgw_icon.c9ae1adc.png";